var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "event-reg-form"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('section', {
    staticClass: "col-md-8 pr-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "input-field form-group otp-phone-field"
  }, [_c('vue-tel-input', {
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.submittedOtpForm && _vm.getError('phone') || !_vm.phone.valid
    },
    attrs: {
      "disabled": _vm.otpVerifyStatus
    },
    on: {
      "input": _vm.validatePhone,
      "country-changed": _vm.countryChanged
    },
    model: {
      value: _vm.form.phone,
      callback: function ($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  }), _vm.submittedOtpForm && _vm.getError('phone') || !_vm.phone.valid ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" Please enter a valid phone number ")]) : _vm._e(), _c('small', {
    staticClass: "text-help-info",
    staticStyle: {
      "line-height": "2px"
    }
  }, [_vm._v(" We'll use your number only for verification. This will not be visible to other users. ")])], 1)]), _c('div', {
    staticClass: "col-md-6"
  }, [!_vm.otpVerifyStatus && _vm.form.phone ? _c('div', {
    staticClass: "display-phone"
  }, [_c('strong', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.phone.number))])]) : _vm._e()])]), _vm.showOtpOptions ? _c('div', {
    staticClass: "custom-radio-btn mt-1 mb-1"
  }, [_c('div', {
    staticClass: "custom-control custom-radio custom-control-inline text-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.type,
      expression: "form.type"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "type": "radio",
      "id": "smsOtp",
      "value": "sms",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.form.type, "sms")
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.form, "type", "sms");
      }
    }
  }), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "smsOtp"
    }
  }, [_vm._v(" OTP via Sms ")])]), _c('div', {
    staticClass: "custom-control custom-radio custom-control-inline text-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.type,
      expression: "form.type"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "type": "radio",
      "id": "WhatsAppOtp",
      "value": "whatsapp"
    },
    domProps: {
      "checked": _vm._q(_vm.form.type, "whatsapp")
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.form, "type", "whatsapp");
      }
    }
  }), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "WhatsAppOtp"
    }
  }, [_vm._v(" OTP via WhatsApp ")])]), !_vm.otpSentStatus ? _c('button', {
    staticClass: "btn-universal",
    class: {
      otpActive: _vm.form.phone
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendOtp
    }
  }, [_vm.getLoading ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v(" Send OTP ")]) : _vm._e(), _vm.otpSentStatus && !_vm.otpVerifyStatus ? _c('button', {
    staticClass: "btn-universal",
    class: {
      otpActive: _vm.form.phone
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendOtp
    }
  }, [_vm.getLoading ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v(" Resend OTP ")]) : _vm._e()]) : _vm._e(), _vm.otpSentStatus && !_vm.otpVerifyStatus ? _c('div', {
    staticClass: "input-field rounded border bg-light p-3 mt-4 text-12"
  }, [_vm._v(" Verify OTP "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verifyForm.otp,
      expression: "verifyForm.otp"
    }],
    staticClass: "form-control bg-white",
    class: {
      'is-invalid': _vm.submittedVerifyForm && _vm.getVerifyError('otp')
    },
    attrs: {
      "type": "text",
      "placeholder": "Please enter OTP here"
    },
    domProps: {
      "value": _vm.verifyForm.otp
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.verifyForm, "otp", $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "btn-universal border-0",
    staticStyle: {
      "height": "55px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.verifyOtp
    }
  }, [_vm._v(" VERIFY OTP ")])])])]) : _vm._e(), _vm.otpVerifyStatus ? _c('div', {
    staticClass: "mt-3 text-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(" Your phone number has been verified. ")]) : _vm._e(), _vm.otpVerifyStatus ? _c('div', {
    staticClass: "text-button-wrap",
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.acceptCheck.agree,
      expression: "acceptCheck.agree"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "id": "agree",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.acceptCheck.agree) ? _vm._i(_vm.acceptCheck.agree, null) > -1 : _vm.acceptCheck.agree
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.acceptCheck.agree,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.acceptCheck, "agree", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.acceptCheck, "agree", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.acceptCheck, "agree", $$c);
        }
      }
    }
  }), _c('label', {
    staticClass: "custom-control-label text-12 mt-3 terms-condition-label",
    attrs: {
      "for": "agree"
    }
  }, [_vm._v(" By clicking submit button, I agree to your "), _c('router-link', {
    attrs: {
      "target": "_blank",
      "to": {
        name: 'terms'
      }
    }
  }, [_vm._v("Terms and Conditions")]), _vm._v(" and "), _c('router-link', {
    attrs: {
      "target": "_blank",
      "to": {
        name: 'privacy'
      }
    }
  }, [_vm._v("Privacy Policy")])], 1)]), !_vm.acceptCheck.agree ? _c('small', {
    staticClass: "text-danger ml-4"
  }, [_vm._v("Please agree to the terms and conditions")]) : _vm._e()]) : _vm._e()])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }